/**
 * Section: Benefit icons
 * ------------------------------------------------------------------------------
 * Load accordion logic for benefit icons (if required).
 *
 * @namespace benefitIcons
 */

import log from 'salvo-lite/log'

import cssClasses from '../helpers/cssClasses'
import { on } from '../helpers/utils'

class BenefitIcons {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem

        this._selectors = {
            container: '[js-benefit-icons="container"]',
            open: '[js-benefit-icons="open"]',
            close: '[js-benefit-icons="close"]'
        }

        this._nodeSelectors = {
            container: document.querySelector(this._selectors.container),
            open: document.querySelector(this._selectors.open),
            close: document.querySelector(this._selectors.close)
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        if (this._nodeSelectors.container.getAttribute('data-accordion') === 'true') {
            on('click', this._nodeSelectors.open, () => this.handleOpen())
            on('click', this._nodeSelectors.close, () => this.handleClose())
        }
    }

    handleOpen () {
        this._nodeSelectors.container.classList.add(cssClasses.active)
    }

    handleClose () {
        this._nodeSelectors.container.classList.remove(cssClasses.active)
    }
}

export default BenefitIcons



// WEBPACK FOOTER //
// ./src/resources/scripts/components/BenefitIcons.js